// 站点级 SEO / GEO 配置（集中维护，供 vue-meta 与预渲染插件共用）
// 注意：站点已切换为 history 模式，所有公开页均为干净路径（无 #）。

const SITE_URL = 'https://www.cfbrain.cn'
const COMPANY_NAME = '化学纤维产业大脑'
const DEFAULT_DESCRIPTION =
  '化纤行业一站式方案提供服务商。立足产业赋能，以技术支撑+数据运营+应用服务为核心，为化纤企业提供数字化赋能、产业生态服务与经济治理数字化手段。'

// 公开、可预渲染、允许 AI 抓取的路由（与 sitemap.xml 保持一致）
const PUBLIC_ROUTES = [
  '/',
  '/knowledge-center',
  '/knowledge-center/polyester-fiber-basics',
  '/knowledge-center/poy-dty-fdy-differences',
  '/knowledge-center/pta-meg-pet-relationship',
  '/knowledge-center/polyester-chip-guide',
  '/knowledge-center/recycled-polyester-guide',
  '/knowledge-center/nylon-6-nylon-66',
  '/knowledge-center/spandex-fiber-guide',
  '/knowledge-center/viscose-fiber-guide',
  '/knowledge-center/polypropylene-fiber-guide',
  '/knowledge-center/acrylic-fiber-guide',
  '/knowledge-center/differentiated-fibers',
  '/knowledge-center/yarn-count-units',
  '/knowledge-center/draw-ratio-and-orientation',
  '/knowledge-center/moisture-regain-and-comfort',
  '/knowledge-center/melt-spinning-process',
  '/knowledge-center/polyester-dyeing-guide',
  '/knowledge-center/fiber-quality-indicators',
  '/knowledge-center/chemical-fiber-energy-management',
  '/knowledge-center/predictive-maintenance',
  '/knowledge-center/chemical-fiber-safety-environment',
  '/about',
  '/industryknowledge',
  '/industrystandard',
  '/experts',
  '/industrymap',
  '/newsmart',
  '/exhibition',
  '/risefall',
  '/cloudlive',
  '/infotom',
  '/overview',
  '/prosperity',
  '/indexmacro',
  '/pallet',
  '/palletabout',
  '/palletmall',
  '/search',
  '/custom',
  '/industrial',
  '/printingdyeing',
  '/sentiment',
  '/matching',
  '/cloudmall'
]

// 各公开页中文名称（用于 title / 面包屑 / 描述拼接）
const PAGE_LABELS = {
  '/': '首页',
  '/knowledge-center': '化纤行业知识中心',
  '/about': '关于我们',
  '/industryknowledge': '行业知识',
  '/industrystandard': '行业标准',
  '/experts': '行业专家',
  '/industrymap': '行业图谱',
  '/newsmart': '新智造',
  '/exhibition': '云会展',
  '/risefall': '涨跌榜',
  '/cloudlive': '云直播',
  '/infotom': '信息通',
  '/overview': '化纤总览',
  '/prosperity': '景气指数',
  '/indexmacro': '化纤指数',
  '/pallet': '托盘',
  '/palletabout': '托盘服务',
  '/palletmall': '托盘商城',
  '/search': '全站搜索',
  '/custom': '云定制',
  '/industrial': '工业APP',
  '/printingdyeing': '数智印染',
  '/sentiment': '舆情分析',
  '/matching': '撮合交易',
  '/cloudmall': '云商城'
}

// 面包屑映射（位置从首页起算）；未列出的页默认只含首页>本页
const PAGE_BREADCRUMB = {
  '/knowledge-center': [{ name: '首页', url: '/' }, { name: '化纤行业知识中心', url: '/knowledge-center' }],
  '/about': [{ name: '首页', url: '/' }, { name: '关于我们', url: '/about' }],
  '/industryknowledge': [{ name: '首页', url: '/' }, { name: '行业知识', url: '/industryknowledge' }],
  '/industrystandard': [{ name: '首页', url: '/' }, { name: '行业标准', url: '/industrystandard' }],
  '/experts': [{ name: '首页', url: '/' }, { name: '行业专家', url: '/experts' }],
  '/industrymap': [{ name: '首页', url: '/' }, { name: '行业图谱', url: '/industrymap' }],
  '/newsmart': [{ name: '首页', url: '/' }, { name: '新智造', url: '/newsmart' }],
  '/exhibition': [{ name: '首页', url: '/' }, { name: '云会展', url: '/exhibition' }],
  '/risefall': [{ name: '首页', url: '/' }, { name: '涨跌榜', url: '/risefall' }],
  '/cloudlive': [{ name: '首页', url: '/' }, { name: '云直播', url: '/cloudlive' }],
  '/infotom': [{ name: '首页', url: '/' }, { name: '信息通', url: '/infotom' }],
  '/overview': [{ name: '首页', url: '/' }, { name: '化纤总览', url: '/overview' }],
  '/prosperity': [{ name: '首页', url: '/' }, { name: '景气指数', url: '/prosperity' }],
  '/indexmacro': [{ name: '首页', url: '/' }, { name: '化纤指数', url: '/indexmacro' }],
  '/pallet': [{ name: '首页', url: '/' }, { name: '托盘', url: '/pallet' }],
  '/palletabout': [{ name: '首页', url: '/' }, { name: '托盘', url: '/pallet' }, { name: '托盘服务', url: '/palletabout' }],
  '/palletmall': [{ name: '首页', url: '/' }, { name: '托盘', url: '/pallet' }, { name: '托盘商城', url: '/palletmall' }],
  '/search': [{ name: '首页', url: '/' }, { name: '全站搜索', url: '/search' }],
  '/custom': [{ name: '首页', url: '/' }, { name: '云定制', url: '/custom' }],
  '/industrial': [{ name: '首页', url: '/' }, { name: '工业APP', url: '/industrial' }],
  '/printingdyeing': [{ name: '首页', url: '/' }, { name: '数智印染', url: '/printingdyeing' }],
  '/sentiment': [{ name: '首页', url: '/' }, { name: '舆情分析', url: '/sentiment' }],
  '/matching': [{ name: '首页', url: '/' }, { name: '撮合交易', url: '/matching' }],
  '/cloudmall': [{ name: '首页', url: '/' }, { name: '云商城', url: '/cloudmall' }]
}

module.exports = {
  SITE_URL,
  COMPANY_NAME,
  DEFAULT_DESCRIPTION,
  PUBLIC_ROUTES,
  PAGE_LABELS,
  PAGE_BREADCRUMB
}



// WEBPACK FOOTER //
// ./src/seo.config.js